import { inject, Injectable } from '@angular/core';
import {
  AppState,
  IState,
  IUserInfo,
  Products,
} from '../../interfaces/state-interface';
import { Token } from 'src/app/app.model';
import { CookiesService } from '../cookies/cookies.service';
import { NS_Enums } from 'src/app/static/namespace';

const STORE_KEY = 'SARAS_STORE';
// const TOKEN_KEY = 'SARAS_TOKEN';
// const USER_KEY = 'SARAS_USER';
const RESEND_LINK_TIMER = 'SARAS_LINK_TIMER';

@Injectable({
  providedIn: 'root',
})
export class StoreService {
  private state: IState;
  private cookiesStore: CookiesService = inject(CookiesService);

  constructor() {}

  init() {
    this.state = this.get() || emptyState;
  }

  private save(info: any, key: string = STORE_KEY) {
    localStorage.setItem(key, JSON.stringify(info));
  }

  resetStore(key: string = '') {
    localStorage.setItem(STORE_KEY, '');
  }

  private get(key: string = STORE_KEY): any {
    try {
      const item = localStorage.getItem(key);
      if (item) {
        return JSON.parse(item);
      }
      return null;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  getStatus() {
    return this.state.status;
  }
  setStatus(status: AppState = AppState.NONE) {
    this.state.status = status;
    this.save(this.state);
  }
  getUserFromState() {
    return this.state.user;
  }
  setUserFromState(user: IUserInfo) {
    this.state.user = user || {};
    this.cookiesStore.putObject(NS_Enums.cacheKeysEnum.user_details, user);
    this.save(this.state);
  }

  getProduct(): Products {
    return this.state?.product || Products.GLOBAL;
  }
  setProduct(product: Products) {
    this.state.product = product;
  }

  setUser(user: any) {
    this.cookiesStore.putObject(
      NS_Enums.cacheKeysEnum.user_details,
      user,
      true
    );
    this.save(user, NS_Enums.cacheKeysEnum.user_details);
  }
  getUser(): any {
    return this.cookiesStore.getObject(NS_Enums.cacheKeysEnum.user_details);
  }
  setUserId(id: string) {
    this.cookiesStore.putObject(NS_Enums.cacheKeysEnum.saras_user_id, {
      userId: id,
    });
    this.save(id, NS_Enums.cacheKeysEnum.saras_user_id);
  }
  getUserId(): string | null {
    let user: any = this.cookiesStore.getObject(
      NS_Enums.cacheKeysEnum.saras_user_id
    );
    let saras_global: any = this.cookiesStore.getObject(NS_Enums.saras_global);
    return (
      user?.userId ||
      this.get(NS_Enums.cacheKeysEnum.saras_user_id) ||
      saras_global?.userId
    );
  }

  setToken(token: Token | null) {
    this.cookiesStore.putObject(
      NS_Enums.cacheKeysEnum.saras_auth_key,
      token?.token,
      true
    );
    this.save(token, NS_Enums.cacheKeysEnum.saras_auth_key);
  }
  getToken(): string {
    return this.cookiesStore.getObject(NS_Enums.cacheKeysEnum.saras_auth_key);
    // return this.get(NS_Enums.cacheKeysEnum.saras_auth_key);
  }

  setCustomToken(customToken: string) {
    this.save(customToken, NS_Enums.cacheKeysEnum.saras_custom_auth_key);
  }
  getCustomToken() {
    return this.get(NS_Enums.cacheKeysEnum.saras_custom_auth_key);
  }

  setSarasPortalData(data: string) {
    this.save(data, NS_Enums.cacheKeysEnum.saras_global_portal);
  }
  getSarasPortalData() {
    return this.get(NS_Enums.cacheKeysEnum.saras_global_portal);
  }

  setResendLiknTimestamp(timestamp: any) {
    const timerObj = { timestamp };

    this.save(JSON.stringify(timerObj), RESEND_LINK_TIMER);
  }
  getResendLinkTimestamp() {
    try {
      const timerStr: any = this.get(RESEND_LINK_TIMER);
      if (timerStr) {
        const timerObj = JSON.parse(timerStr);
        return timerObj.timestamp || 0;
      }
      return 0;
    } catch (e) {
      console.log(e);
      return 0;
    }
  }
  removeResendLinkTimestamp() {
    this.save(null, RESEND_LINK_TIMER);
  }
}

const emptyState = {
  status: AppState.NONE,
  user: {},
};
